<!-- Standalone header (no hamburger) -->
<header class="vt-header">
  <nav class="navbar container-fluid">
    <div class="brand">
      <a routerLink="/" class="brand-link">
        <img src="assets/images/Veeduplan logo.png" alt="VeeduPlan Logo" class="logo">
      </a>
    </div>
    <!--<div class="contact">
      <a href="mailto:info@veeduplan.in" class="contact-link">info@veeduplan.in</a>
    </div>-->
  </nav>
</header>

<!-- Page banner (base color) -->
<section class="viewall-banner">
  <div class="container banner-grid">
    <div>
      <h1 class="banner-title">{{ packageId ? 'Package Templates' : 'All Floor Plan Templates' }}</h1>
      <p class="banner-subtitle">Browse every template in one place.</p>
    </div>
    <div class="banner-actions">
      <button class="back-button" type="button" routerLink="/home">
        ← Back
      </button>
      <button class="cart-button" type="button" (click)="goToCart()">
        🛒 Go to Cart <span class="badge">{{ cartCount }}</span>
      </button>
    </div>
  </div>
</section>

<section class="product-section">
  <div class="container" *ngIf="templates.length > 0">
    <h2 class="section-title">{{ packageId ? 'Package Templates' : 'All Floor Plan Templates' }}</h2>
    <div class="product-grid">
      <div class="product-card" *ngFor="let template of templates">
        <div class="card-header">
          <button class="cart-icon" type="button" (click)="toggleCart(template)"
            [title]="isInCart(template.id) ? 'Remove from Cart' : 'Add to Cart'">
            <i class="fas fa-shopping-cart" [class.added]="isInCart(template.id)"></i>
          </button>
        </div>
        <img [src]="template.image" [alt]="template.title" class="product-image">
        <div class="product-info">
          <h4 class="product-title">{{template.title}}</h4>
          <p class="product-description">{{ template.description }}</p>
          <button class="view-button" type="button" [routerLink]="['/template-preview', template.id]"><i
              class="fas fa-eye"></i> Preview</button>
        </div>
      </div>
    </div>
    <!--<div class="section-button">
      <button class="cta-button" type="button">View All Floor Plans</button>
    </div>-->
  </div>
  <div class="no-templates" *ngIf="templates.length === 0">
    <p>No Templates Found</p>
  </div>
</section>

<app-footer></app-footer>

